import axios from 'axios'
import appConfig from 'configs/app.config'
import { TOKEN_TYPE, REQUEST_HEADER_AUTH_KEY } from 'constants/api.constant'
import { PERSIST_STORE_NAME } from 'constants/app.constant'
import deepParseJson from 'utils/deepParseJson'
import store from '../store'
import { onSignOutSuccess } from '../store/auth/sessionSlice'

const unauthorizedCode = [401]

const BaseService = axios.create({
    timeout: 60000,
    baseURL: appConfig.apiPrefix,
})

BaseService.interceptors.request.use(
    (config) => {
        if (config.skipAuth) {
            config.headers['ngrok-skip-browser-warning'] = 'true'
            return config
        }

        const rawPersistData = localStorage.getItem(PERSIST_STORE_NAME)
        const persistData = deepParseJson(rawPersistData)

        let accessToken = persistData.auth.session.token

        if (!accessToken) {
            const { auth } = store.getState()
            accessToken = auth.session.token
        }

        if (accessToken) {
            config.headers[
                REQUEST_HEADER_AUTH_KEY
            ] = `${TOKEN_TYPE}${accessToken}`
        }

        config.headers['ngrok-skip-browser-warning'] = 'true';


        return config
    },
    (error) => {
        return Promise.reject(error)
    }
)

BaseService.interceptors.response.use(
    (response) => {
        return response
    },
    (error) => {
        const { response, config } = error

        if (response && unauthorizedCode.includes(response.status)) {
            if (config?.skipAuth) {
                return Promise.reject(error)
            }
            // Skip auto-reload for validate auth endpoint - let ProtectedRoute handle it
            if (config?.url?.includes('/auth/validate')) {
                // Don't reload - let ProtectedRoute handle the redirect
                store.dispatch(onSignOutSuccess())
                localStorage.clear()
            } else {
                store.dispatch(onSignOutSuccess())
                localStorage.clear()
                window.location.reload()
            }
        }

        return Promise.reject(error)
    }
)

export default BaseService
